import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { showData } from "../../Utils/APIs/commonShowAPI";
import { getCookie } from "../../Utils/cookies";
import { FaFilter } from "react-icons/fa";
import Filter from "../../Components/filter/Index";
import ComplaintDetails from "../ComplaintDetails/Index";
import VerifyComplaint from "../verifyComplaint/Index";
import { IoClose } from "react-icons/io5";

const Index = () => {
  const Navigate = useNavigate();
  const {id} = useParams() || {id:null};
  const [selectedStage, setSelectedStage] = useState(id || null);
  useEffect(() => {
    setSelectedStage(id);
  }, [id]);
  useEffect(() => {
    const token = getCookie("token");
    if (!token) {
      Navigate("/login");
    }
  }, [Navigate]);

  const empData = JSON.parse(getCookie("empData"));
  const isAdmin = ["Admin", "Service", "Tollfree" , "Super Admin"].includes(empData?.role);
  const isVerifyTeam = ["Verify Team-1", "Verify Team-2"].includes(
    empData?.role
  );
  const LIMIT = 20;
  var SrNo = 1;
  const [page, setPage] = useState(1);
  const [complaintData, setComplaintData] = useState([]);
  const [complaintId, setComplaintId] = useState(null);
  const [searchBtnClicked, setSearchBtnClicked] = useState(false);
  // filter field
  const [trackingId, setTrackingId] = useState("");
  const [saralId, setSaralId] = useState("");
  const [contactNo, setContactNo] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState();
  const [filertVisible, setFilertVisible] = useState(false);
  const filters = `stage=${selectedStage}&limit=${LIMIT}&page=${page}&saralId=${saralId}&contact=${contactNo}&trackingId=${trackingId}&startDate=${startDate}&endDate=${endDate}`; // new filter
  useEffect(() => {
    setComplaintData([]);
    showData(`farmer/showComplaint?${filters}`, setComplaintData);
  }, [selectedStage, searchBtnClicked, page]);
  const updateComplaint = (e, id) => {
      setComplaintId(id);
  };

  const formatDate = (date) => {
    const store = new Date(date);
    return (
      store.getDate() + "/" + (store.getMonth() + 1) + "/" + store.getFullYear()
    );
  };
  const filterToggle = () => {
    setSelectedStage(null);
    setFilertVisible(!filertVisible);
  };
  const closeModal = () => {
    setComplaintId(null);
  };
  return (
    <>
      <button
        className="p-1 pl-5 pr-5 rounded-md absolute bottom-4 left-64 text-white bg-gray-800"
        onClick={() => {
          setPage(page - 1);
        }}
      >
        Back
      </button>
      <button
        className="p-1 pl-5 pr-5 rounded-md absolute bottom-4 right-16 text-white bg-gray-800"
        onClick={() => {
          setPage(page + 1);
        }}
      >
        Forward
      </button>
      <div className="overflow-auto h-[calc(100vh-8rem)]">
        <div className="relative">
          <table className="relative w-full text-sm text-left rtl:text-right text-gray-500">
            <thead className="text-xs border border-gray-150 bg-gray-800 text-gray-100 uppercase">
              <th scope="col" className="px-4 py-2 text-center font-semibold">
                #
              </th>
              <th scope="col" className="px-4 py-2 text-center font-semibold">
                Tracking Id
              </th>
              <th scope="col" className="px-4 py-2 text-center font-semibold">
                Register Date
              </th>
              <th scope="col" className="px-4 py-2 text-center font-semibold">
                Update Date
              </th>
              <th scope="col" className="px-4 py-2 text-center font-semibold">
                Name
              </th>
              <th scope="col" className="px-4 py-2 text-center font-semibold">
                Contact
              </th>
              <th scope="col" className="px-4 py-2 text-center font-semibold">
                Priority
              </th>
              <th scope="col" className="px-4 py-2 text-center font-semibold">
                Complaint Details
              </th>
              <th scope="col" className="px-4 py-2 text-center font-semibold">
                Saral Id
              </th>
              <th scope="col" className="px-4 py-2 text-center font-semibold">
                State
              </th>
              <th scope="col" className="px-4 py-2 text-center font-semibold">
                District
              </th>
              <th scope="col" className="px-4 py-2 text-center font-semibold">
                Product
              </th>
              <th scope="col" className="px-4 py-2 text-center font-semibold">
                Stage
              </th>
            </thead>
            <tbody>
              {complaintData?.map((data, index) => (
                <>
                  <tr
                    className={`${data?.Stage?.[0]?.stage === "Verify Stage 2" ? "bg-green-50 hover:bg-green-100" : "bg-red-100 hover:bg-red-200"} border-b hover:bg-gray-400 text-gray-800 hover:text-gray-900`}
                    onClick={(e) => {
                      updateComplaint(e, data._id);
                    }}
                  >
                    <th
                      scope="row"
                      className="px-2 font-medium text-gray-900 whitespace-nowrap"
                    >
                      {SrNo++ + (page - 1) * LIMIT}
                    </th>
                    <th
                      scope="row"
                      className="px-2 font-medium text-xs text-center text-gray-900 whitespace-nowrap "
                    >
                      {data.trackingId}
                    </th>
                    <th
                      scope="row"
                      className="px-2 font-medium text-xs text-center text-gray-900 whitespace-nowrap "
                    >
                      {formatDate(data.created_At)}
                    </th>
                    <th
                      scope="row"
                      className="px-2 font-medium text-xs text-center text-gray-900 whitespace-nowrap "
                    >
                      {formatDate(data.updated_At)}
                    </th>
                    <td className="px-2 text-xs text-center">{data?.Farmer[0]?.farmerName}</td>
                    <td className="px-2 text-xs text-center">
                      {data.contact } <br/>{ data?.Farmer[0]?.contact }
                    </td>
                    {/* <td className="px-2 text-xs  text-center">{data.authority}</td> */}
                    <th
                      scope="row"
                      className="px-2 text-xs font-medium text-center text-gray-900"
                    >
                      {data.priority}
                    </th>
                    <td className="text-center">
                      <div className="group relative">
                        <span className="block overflow-hidden h-10 max-w-auto group-hover:h-auto">
                          {data.complaintDetails}
                        </span>
                      </div>
                    </td>
                    <td className="px-2 text-xs text-center">
                      {data?.Farmer[0]?.saralId}
                    </td>
                    <td className="px-2 text-xs text-center">
                      {data?.Farmer[0]?.state}
                    </td>
                    <td className="px-2 text-xs text-center">
                      {data?.Farmer[0]?.district}
                    </td>
                    
                    <td className="px-2 text-xs text-center">
                      {data?.Farmer[0]?.HP + "HP " + data?.Farmer[0]?.AC_DC}
                    </td>
                    <td className="px-2 text-xs">{data?.Stage[0]?.stage}</td>
                  </tr>
                </>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <button
        className="fixed bottom-24 right-12 bg-yellow-400 p-3 rounded-lg font-medium shadow-lg"
        onClick={filterToggle}
      >
        <FaFilter />
      </button>
      {filertVisible && (
        <Filter
          toggleState={setFilertVisible}
          trackingId={trackingId}
          setTrackingId={setTrackingId}
          contactNo={contactNo}
          setContactNo={setContactNo}
          setSaralId={setSaralId}
          saralId={saralId}
          searchBtn={searchBtnClicked}
          setSearchBtn={setSearchBtnClicked}
          startDate={startDate}
          setStartDate={setStartDate}
          endDate={endDate}
          setEndDate={setEndDate}
        />
      )}
      {complaintId !== null && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 h-full">
          <div className="relative bg-white rounded-lg shadow-lg p-6 w-full max-w-7xl overflow-auto max-h-[96vh]">
            {isAdmin && (
              <ComplaintDetails
                _id={complaintId}
                setComplaintId={setComplaintId}
              />
            )}

            {isVerifyTeam && <VerifyComplaint _id={complaintId} />}

            <button
              className="absolute top-0 right-4 mt-4 px-1 py-1 bg-red-500 text-white rounded hover:bg-red-600"
              onClick={closeModal}
            >
              <IoClose />
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default Index;
